import { useEffect, useState } from 'react'
import { Button, DatePicker, Input, Progress, TimePicker, message } from 'antd'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
import type { DatePickerProps } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import type { Dayjs } from 'dayjs'
import ShadeAnalysisResult from './result'
import useStore from '@/hooks/useStore'
import Modal from '@/components/Modal'
import Loading from '@/components/Content/RightNavCtrl/loading'

// import * as Cesium from '@cesiumgs/cesium-analytics'
// import type { Viewer } from '@cesiumgs/cesium-analytics'
// import { Math } from '@cesiumgs/cesium-analytics'
// import type Draw from '@/components/Cesium/Draw/Draw'
// import type DrawAction from '@/components/Cesium/Draw/DrawAction'
// import { DrawType } from '@/components/Cesium/Draw/DrawType'
// import { DrawEventType } from '@/components/Cesium/Draw/DrawEventType'

// import type { IModalProps } from '@/components/Content/RightNavCtrl/data'

// import { word2Lnglat } from '@/components/Cesium/CartesianOrWkt'
// import { queryaddress } from '@/service/rightNavCtrl'
import './index.less'

const prefix = 'shadeAnalysis'
// let drawTool: Draw
function ShadeAnalysis() {
  const [dateValue, setDateValue] = useState(dayjs())
  const [timestart, setTimestart] = useState<Dayjs | null>(dayjs('07:00:00', 'HH:mm:ss'))
  const [timeEnd, setTimeEnd] = useState<Dayjs | null>(dayjs('08:00:00', 'HH:mm:ss'))
  const [wc, setwc] = useState('5')
  const [hc, sethc] = useState('5')
  const [disabled, setDisabled] = useState(true)
  const [isLoading2, setIsLoading2] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  const shadeAnalysisStore = useStore('shadeAnalysis')
  const mapStore = useStore('mapStore')
  const uiStore = useStore('uiStore')
  useEffect(() => {
    shadeAnalysisStore.initfn(mapStore.viewer)
    return () => {
      shadeAnalysisStore.distory()
    }
  }, [])
  const changeDate: DatePickerProps['onChange'] = (val: any) => {
    setDateValue(val)
  }

  const onChangeStart = (time: Dayjs | null, dates: string | string[]) => {
    setTimestart(time)
  }
  const onChangeEnd = (time: Dayjs | null, dates: string | string[]) => {
    setTimeEnd(time)
  }
  const inputChangewc = (enevt: any) => {
    setwc(enevt.target.value || 0)
  }
  const inputChangehc = (enevt: any) => {
    sethc(enevt.target.value || 0)
  }
  const handleDrawPoint = () => {
    // drawTool = new Draw(window.cviewer)
    // const action: DrawAction = drawTool.create(DrawType.Polyline, {
    //   useDefaultEntity: true,
    // })
    // action.on(DrawEventType.VertexAdd, (evt) => {

    // })
    // action.on(DrawEventType.Complete, (evt) => {
    //   action.destroy()
    // })
    handleDiffCloseModal()
    shadeAnalysisStore.drawLineMeasureSpace((data: any) => {
      setDisabled(false)
    })
  }
  const handleClearPoint = () => {
    // drawTool?.reset()
    shadeAnalysisStore.undrawLineMeasureSpace()
  }
  const handleAnalysis = () => {
    if (shadeAnalysisStore.tempDest.length <= 0) {
      messageApi.warning('place Draw Line')
      return false
    }
    if (!timestart) {
      messageApi.warning('place input Start Time')
      return false
    }
    if (!timeEnd) {
      messageApi.warning('place input end time')
      return false
    }
    setIsLoading2(true)
    shadeAnalysisStore.startAnalysis(dayjs(dateValue).format('YYYY-MM-DD'), timestart.format('HH:mm:ss'), timeEnd.format('HH:mm:ss'), wc, hc, (flag: boolean) => {
      if (!flag) {
        setIsLoading2(false)
      }
    })
  }

  const handleDiffCloseModal = () => {
    shadeAnalysisStore.visibleResult = false
  }
  const handleCancel = () => {
    shadeAnalysisStore.isLoading = false
  }
  return (
    <>
      {contextHolder}
      <div className={`${prefix}`}>
        <div className={`${prefix}-txt`}>
          시점 지정
          <span>* 시점을 지도에서 선택하세요</span>
        </div>
        <div className={`${prefix}-btn`}>
          <Button onClick={handleDrawPoint} className={`${prefix}-btn-sure`}>
            영역 지정
          </Button>
          <Button disabled={disabled} onClick={handleClearPoint} className={`${prefix}-btn-cancel`}>
            지정 취소
          </Button>
        </div>

        <div className={`${prefix}-inputLine`}>
          <strong className={`${prefix}-inputLine-title`}>분석일시 지정</strong>
          <div className={`${prefix}-inputLine-inputBox`}>
            <span>날짜 </span>
            <DatePicker className={`${prefix}-inputLine-inputBox-input`}
              value={dateValue} onChange={changeDate} />

          </div>
          <div className={`${prefix}-inputLine-inputBox`}>
            <span>시간</span>
            <div className={`${prefix}-inputLine-inputBox-input`}>
              <TimePicker value={timestart} onChange={onChangeStart} />-
              <TimePicker value={timeEnd} onChange={onChangeEnd} />

            </div>

          </div>
        </div>

        <div className={`${prefix}-inputLine`}>
          <strong className={`${prefix}-inputLine-title`}>그리드 지정</strong>
          <div className={`${prefix}-inputLine-inputBox`}>
            <span>가로</span>
            <Input className={`${prefix}-inputLine-inputBox-input`} value={wc} onChange={inputChangewc} />
          </div>
          <div className={`${prefix}-inputLine-inputBox`}>
            <span>세로</span>
            <Input className={`${prefix}-inputLine-inputBox-input`} value={hc} onChange={inputChangehc} />
          </div>
        </div>
        <div className={`${prefix}-bottom`}>
          <Button disabled={disabled} onClick={handleAnalysis} >분석 실행</Button>
        </div>

        <Modal
          visible={shadeAnalysisStore.visibleResult}
          headerTitle={'음영 분석 결과'}
          handleClose={() => {
            handleDiffCloseModal()
          }}
          styles={{
            position: 'fixed',
            width: '400px',
            top: `${window.SystemConfig.uiConfig.headerHeight + 30}px`,
            left: `${uiStore.Content_Left_Width + 30 + 410}px`,
            zIndex: 10,
          }}
        >
          <ShadeAnalysisResult></ShadeAnalysisResult>
        </Modal>
        {shadeAnalysisStore.isLoading
          ? (
            <div className={`${prefix}-loading`}>
              <div className={`${prefix}-loading-title`}>분석 중입니다</div>
              <LoadingOutlined style={{ fontSize: '30px' }} />
              <div className={`${prefix}-loading-box`}>
                <div className={`${prefix}-loading-box-curr`}>{shadeAnalysisStore.tmSts}</div>
                <Progress percent={shadeAnalysisStore.percent} status="active" showInfo={false} />
                <div className={`${prefix}-loading-box-range`}>
                  <span>{dayjs(timestart).format('HH:mm:ss')}</span>
                  <span>{dayjs(timeEnd).format('HH:mm:ss')}</span>
                </div>
              </div>
              <div className={`${prefix}-loading-btn`} onClick={handleCancel}>
                취소
              </div>
            </div>
            )
          : null}
        {isLoading2 && <Loading></Loading>}

      </div>
    </>
  )
}

export default observer(ShadeAnalysis)
